<template>
  <v-content fluid class="pa-0">
    <component
      v-if="componentExists"
      :is="componentInstance"
      v-bind="componentProps"
      @value-change="onValueChange($event)"
      @value-remove="onValueRemove($event)"
    />

    <p v-else>Cannot find mapping for {{ filterName }}</p>
  </v-content>
</template>

<script>
import filtersMapping from "./filters-map";
export default {
  name: "DynamicReportFilter",
  props: {
    report: { type: Object, required: true, default: () => ({}) },
    reportFilter: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      debug: false,
      filterName: this.reportFilter.name,
      filterLabel: this.reportFilter.label,
      filterValue: this.reportFilter.value,
      reportName: this.report.name,
      fName:
        this.reportFilter.filterName &&
        this.reportFilter.filterName.toString() != ""
          ? this.reportFilter.filterName
          : this.reportFilter.name,
    };
  },
  computed: {
    componentInstance() {
      const name = filtersMapping[this.filterName];
      return () => import(`./filters/${name}`);
    },
    componentExists() {
      return filtersMapping[this.filterName] != undefined;
    },
    componentProps() {
      return {
        filter: {
          name: this.filterName,
          label: this.filterLabel,
          value: this.filterValue,
          filterName: this.fName,
          reportName: this.reportName,
        },
        outlined: this.$store.getters.localSettings("outlinedInputs"),
      };
    },
  },
  methods: {
    onValueChange(payload) {
      this.$emit("valueChanged", { name: this.fName, data: payload });
    },
    onValueRemove(valueName) {
      this.$emit("valueRemoved", valueName);
    },
  },
  watch: {
    reportFilter(rf) {
      this.filterName = rf.name;
      this.filterLabel = rf.label;
      this.filterValue = rf.value;
    },
    report(r) {
      this.reportName = r.name;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/gt/reports/DynamicReportFilter.vue